import type { ReferenceChip } from '@/lib/dashboardReferences';

const KIND_LABEL: Record<ReferenceChip['kind'], string> = {
    element: 'Page',
    source: 'Source',
    dashboard: 'Dashboard'
};

export function DashboardReferenceChip({ chip }: { chip: ReferenceChip }) {
    return (
        <div className="flex flex-col gap-1 bg-background px-3 py-2 border border-border rounded-lg w-40 text-left">
            <span className="font-medium text-sm line-clamp-2">
                {chip.dashboardTitle}
            </span>
            <span className="text-muted-foreground text-xs truncate">
                {chip.label}
            </span>
            <span className="self-start bg-muted px-1.5 py-0.5 rounded text-xs">
                {KIND_LABEL[chip.kind]}
            </span>
        </div>
    );
}
